import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const getStorage = (rememberMe: boolean) => (rememberMe ? localStorage : sessionStorage);
const getSetting = <T>(key: string, defaultValue: T) => {
	const localStorageValue = localStorage.getItem(key);
	const sessionStorageValue = sessionStorage.getItem(key);
	// TODO: try to read it from cookie
	return localStorageValue || sessionStorageValue || defaultValue;
};
const saveSetting = (key: string, value: string | boolean | null, rememberMe = false) => {
	const storage = getStorage(rememberMe);
	if (value === null) {
		storage.removeItem(key);
		return;
	}
	storage.setItem(key, `${value}`);
};

const initialState: {
	portalSidebarExpanded: boolean;
	portalSidebarIsHidden: boolean;
} = {
	portalSidebarExpanded: JSON.parse(getSetting("portalSidebarExpanded", "false")),
	portalSidebarIsHidden: JSON.parse(getSetting("portalSidebarIsHidden", "false")),
};

export const settingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		setPortalSidebarExpanded(state, action: PayloadAction<boolean>) {
			saveSetting("portalSidebarExpanded", action.payload, true);
			return {
				...state,
				portalSidebarExpanded: action.payload,
			};
		},
		setPortalSidebarIsHidden(state, action: PayloadAction<boolean>) {
			saveSetting("portalSidebarIsHidden", action.payload, true);
			return {
				...state,
				portalSidebarIsHidden: action.payload,
			};
		},
	},
});
